import { AiOutlineProduct } from "react-icons/ai";
import RadioDropdown from "../../../UI/RadioDropdown/RadioDropdown";
import { RiMapPinTimeLine } from "react-icons/ri";
import { volumeForecastTabActions } from "../../../../store/slices/volume-forecast-tab-slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { tradeAndPromoPlanningTabActions } from "../../../../store/slices/trade-and-promo-planning-tab-slice";
import { VOLUME_FORECAST_TAB_ID } from "../../../../shared/constants";

const HierarchySlicers = () =>{
    const dispatchFn = useDispatch();
    
    const hierarchies = [{ name: 'Brand', value: "Brand" }, { name: 'Brand-Sub Brand', value: "Brand-Sub Brand" },
        { name: 'Brand-Sub Brand-Volume Size', value: "Brand-Sub Brand-Volume Size" }];
    const timelines = [{ name: 'Weekly', value: "Weekly" }, { name: 'Quarterly', value: "Quarterly" },
        { name: 'Periodic', value: "Periodic" }];
    
    const selectedHierarchies = useSelector((state:RootState)=>state.volumeForecastTab.selectedHierarchies);
    
    const dropdownItemChangeHandler = (slicer_name: string, dropdownItemValue: any) => {
            dispatchFn(volumeForecastTabActions.setSelectedHierarchies({
                ...selectedHierarchies,
                [slicer_name]: dropdownItemValue
            }));

            dispatchFn(tradeAndPromoPlanningTabActions.setTabApiDataFetched({
                            [VOLUME_FORECAST_TAB_ID]: false
                        }));
        };

    return (
        <>
        
            <RadioDropdown
                id="product-hierarchy"
                icon={<AiOutlineProduct size={20} />}
                label="Hierarchy"
                selectedValue={selectedHierarchies.product}
                items={hierarchies}
                onItemChanged={(value: any) => dropdownItemChangeHandler("product", value)}
            />

            <RadioDropdown
                id="timeline"
                icon={<RiMapPinTimeLine size={20} />}
                label="Timeline"
                selectedValue={selectedHierarchies.timeline}
                items={timelines}
                onItemChanged={(value: any) => dropdownItemChangeHandler("timeline", value)}
            />
        </>
        
    );
}
export default HierarchySlicers